import { render, staticRenderFns } from "./PartnerDashboard.vue?vue&type=template&id=f2d85550&scoped=true"
import script from "./PartnerDashboard.vue?vue&type=script&lang=js"
export * from "./PartnerDashboard.vue?vue&type=script&lang=js"
import style0 from "./PartnerDashboard.vue?vue&type=style&index=0&id=f2d85550&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2d85550",
  null
  
)

export default component.exports